import { render } from "./mispadres_ingles.vue?vue&type=template&id=58a07aa6&scoped=true"
import script from "./mispadres_ingles.vue?vue&type=script&lang=js"
export * from "./mispadres_ingles.vue?vue&type=script&lang=js"

import "./mispadres_ingles.vue?vue&type=style&index=0&id=58a07aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a07aa6"]])

export default __exports__